import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getSalesReps = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/users/atc`, {
            withCredentials: true
        });
        return response.data.data.salesReps;
    } catch (error) {
        throw error;
    }
}

export const getTechnicians = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/users/technician`, {
            withCredentials: true
        });
        return response.data.data.technicians;
    } catch (error) {
        throw error;
    }
}